import { render } from "./ID.vue?vue&type=template&id=496ab8b6"
import script from "./ID.vue?vue&type=script&lang=js"
export * from "./ID.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__